import React, { Component } from "react";
import axios from 'axios';
import swal from 'sweetalert';
import SimpleReactValidator from 'simple-react-validator';
import PageLoader from './../../Loader/loader';

import "react-addressfinder/dist/widget.css";
import { getApiHeader } from '../../../utils/CommonFunctions';
import { Justify } from "react-bootstrap-icons";
import { Link } from 'react-router-dom/cjs/react-router-dom';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export default class SimServices extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            selectedNumber: '',
            cancellationReason: '',
            agreeToCharges: false,
            mobileNumbers: [],
            confirmPopupMsg:'',
            cancellationReasons: [
                { value: 'travelling_abroad', label: 'I am travelling abroad' },
                { value: 'switching_provider', label: 'Switching to another provider' },
                { value: 'service_issues', label: 'Service quality issues' },
                { value: 'financial_reasons', label: 'Financial reasons' },
                { value: 'other', label: 'Other' }
            ],
            
            agreeTermsError:false,




        }
        this.validator = new SimpleReactValidator();
    }


    componentDidMount() {
        this.handleIntialFetch()
    }


    handleIntialFetch = async () => {
        try {
            this.setState({ loading: true });
            const headers = await getApiHeader()
           
            const response = await axios.get(`${SERVER_URL}postpaid/active_numbers `, { headers })
            if (response.status === 200) {
                this.setState({ loading: false });
                const data = response.data.data.list
                this.setState({ mobileNumbers: data })
            }else{
                    
                swal("Error", response.data.message || "Something went wrong!", "error").then(()=>
                    window.location.href = '/service-list'
                );
               
            }
        } catch (error) {

            swal("Error", error.response.data.message, "error").then(()=> window.location.href = '/service-list');
            
        }

    }


    handleInputChange = (field, value) => {
        this.setState({ [field]: value });
    }

    handleCheckboxChange = () => {
        this.setState({ agreeToCharges: !this.state.agreeToCharges });
    }

    

    handleChange = (event) => {
        const selectedNumber = event.target.value;
        const selectedActivation = this.state.mobileNumbers.find(item => item.mobile_number === selectedNumber);
        
        if (selectedActivation) {
            sessionStorage.setItem("migration-number",selectedNumber)
            this.setState({
                selectedNumber,
                confirmPopupMsg: selectedActivation.confirm_popup_msg,
            });
        }
    };



    handleCancelService = async (e) => {
        e.preventDefault();
        const headers = await getApiHeader();
      
        if (this.validator.allValid()) {

          const { selectedNumber, mobileNumbers } = this.state;

          const selectedActivation = mobileNumbers.find(item => item.mobile_number === selectedNumber);
          
            const choice = await swal({
                title: "A Better Choice, Just for You",
                text: "Switch to a flexible and affordable prepaid plan and enjoy great offers while staying connected.",
                className: "retention-swal",
                closeOnClickOutside: false,
                closeOnEsc: false,
                buttons: {
                    prepaid: {
                        text: "Explore Prepaid Now",
                        value: "prepaid",
                        className: "retention-btn-primary",
                    },
                    continue: {
                        text: "Continue Cancellation",
                        value: "continue",
                        className: "retention-btn-outline",
                    },
                },
            });

            if (choice === "prepaid") {
                window.location.href = "/service-migration";
                return;
            }

           
            swal({
                title: "",
                text: selectedActivation.confirm_popup_msg,
                icon: "warning",
                buttons: ["No", "Yes"],
                dangerMode: true,
            }).then(async (willCancel) => {
                if (willCancel) {
                    this.setState({ loading: true });

                    try {
                        const data = {
                            mobile_number: this.state.selectedNumber,
                            cancel_reason: this.state.cancellationReason,
                            cancel_user_agree: 1,
                        };

                        const response = await axios.post(
                            `${SERVER_URL}postpaid/cancel-sim`,
                            data,
                            { headers }
                        );

                        if (response.status === 200) {
                            swal("Success", response.data.message, "success").then(
                                () => (window.location.href = "/account-summary")
                            );
                            this.setState({
                                selectedNumber: "",
                                cancellationReason: "",
                                agreeToCharges: false,
                            });
                        } else {
                            swal(
                                "Error",
                                response.data.message || "Something went wrong!",
                                "error"
                            ).then(() => window.location.reload());
                        }
                    } catch (error) {
                        swal(
                            "Error",
                            error.response?.data?.message || "Something went wrong!",
                            "error"
                        ).then(() => window.location.reload());
                    }

                    this.setState({ loading: false });
                } else {
                    window.location.href = "/account-summary";
                }
            });


        } else {
          this.validator.showMessages();
          this.forceUpdate();
          this.setState({ agreeTermsError: false });
        }
      };
      













    render() {
        const { loading, selectedNumber, cancellationReason, agreeToCharges, mobileNumbers, cancellationReasons } = this.state;

        return (
            <>
                {loading && <PageLoader />}
                <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor common-class" id="kt_content">
                    <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
                        <div className="row">
                            <div className="col-lg-12 col-xl-12 order-lg-1 order-xl-1">
                                <div className="kt-grid__item kt-grid__item--fluid kt-app__content">
                                    <div className="kt-portlet">
                                        <div className="kt-portlet__head" style={{ backgroundColor: '#C11D6C', color: 'white' }}>
                                            <div className="kt-portlet__head-label">
                                                <h3 className="kt-portlet__head-title" style={{ color: 'white', fontWeight: 'bold' }}>
                                                    Cancel Telsim SIM Only Mobile Service
                                                </h3>
                                            </div>
                                        </div>

                                        <div className="kt-portlet__body" style={{ padding: '40px' }}>
                                            <div
                                                className="service-info-section"
                                                style={{
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '20px',
                                                    backgroundColor: '#fdf2f7',
                                                    padding: '24px 28px',
                                                    borderRadius: '12px',
                                                    marginBottom: '30px',
                                                    border: '1px solid #f4c0d1',
                                                }}
                                            >
                                                {/* decorative circle */}
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        top: '-30px',
                                                        right: '-30px',
                                                        width: '110px',
                                                        height: '110px',
                                                        borderRadius: '50%',
                                                        backgroundColor: '#f4c0d1',
                                                        opacity: 0.45,
                                                        pointerEvents: 'none',
                                                    }}
                                                />

                                                {/* icon */}
                                                <div
                                                    style={{
                                                        flexShrink: 0,
                                                        width: '56px',
                                                        height: '56px',
                                                        borderRadius: '50%',
                                                        backgroundColor: '#C11D6C',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                        <path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3z" />
                                                        <path d="M19 16l.8 2.2L22 19l-2.2.8L19 22l-.8-2.2L16 19l2.2-.8L19 16z" />
                                                    </svg>
                                                </div>

                                                {/* text */}
                                                <div style={{ position: 'relative', flex: 1, minWidth: 0 }}>
                                                    <h4
                                                        style={{
                                                            color: '#C11D6C',
                                                            fontWeight: '600',
                                                            fontSize: '20px',
                                                            lineHeight: '1.3',
                                                            margin: '0 0 6px',
                                                        }}
                                                    >
                                                        A Better Choice, Just for You
                                                    </h4>
                                                    <p
                                                        style={{
                                                            fontSize: '14px',
                                                            color: '#72243e',
                                                            lineHeight: '1.6',
                                                            margin: 0,
                                                        }}
                                                    >
                                                        Switch to a flexible and affordable prepaid plan and enjoy great offers while staying connected.
                                                    </p>
                                                </div>
                                             
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                        <path d="M5 12h14" />
                                                        <path d="M13 6l6 6-6 6" />
                                                    </svg>
                                             
                                            </div>


                                            {/* Service Information */}
                                            <div className="service-info-section" style={{
                                                backgroundColor: '#f8f9fc',
                                                padding: '25px',
                                                borderRadius: '8px',
                                                marginBottom: '30px',
                                                border: '1px solid #e3e6f0'
                                            }}>
                                                <h4 style={{ color: '#C11D6C', marginBottom: '15px', fontWeight: '600' }}>
                                                    Service Cancellation Information
                                                </h4>
                                                <p style={{
                                                    fontSize: '14px',
                                                    color: '#5a5c69',
                                                    lineHeight: '1.6',
                                                    marginBottom: '0',
                                                    textAlign: "justify"
                                                }}>
                                                   Here, you can cancel your Telsim SIM Only Mobile service at any time. 
                                                </p>
                                            </div>

                                            {/* Important Notice */}
                                            <div className="notice-section" style={{
                                                backgroundColor: '#fff3cd',
                                                padding: '20px',
                                                borderRadius: '8px',
                                                marginBottom: '30px',
                                                border: '1px solid #ffeaa7'
                                            }}>
                                                <h5 style={{ color: '#856404', marginBottom: '10px', fontWeight: '600' }}>
                                                    Important Notice:
                                                </h5>
                                                <p style={{
                                                    fontSize: '13px',
                                                    color: '#856404',
                                                    lineHeight: '1.5',
                                                    marginBottom: '0',
                                                    fontStyle: 'italic',
                                                    textAlign: "Justify",
                                                }}>
                                                    If you cancel your service, no refund will be given for any fees that you have already paid to us and your service will stop working within an hour of your request being actioned.

                                                    If you want the SIM to be reactivated later, you must contact Telsim Customer Support, and the process may take 3 to 7 days or vary.
                                                </p>
                                            </div>

                                            <form className="kt-form kt-form--label-right" onSubmit={this.handleCancelService}>
                                                <div className="kt-section kt-section--first">
                                                    <div className="kt-section__body">

                                                        {/* Mobile Number Selection */}
                                                        <div className="form-group row" style={{ marginBottom: '25px' }}>
                                                            <label className="col-xl-3 col-lg-3 col-form-label" style={{
                                                                fontWeight: '600',
                                                                color: '#5a5c69',
                                                                fontSize: '14px'
                                                            }}>
                                                                Select Mobile Number <span style={{ color: '#e74c3c' }}>*</span>
                                                            </label>
                                                            <div className="col-xl-4 col-lg-4">
                                                                <select
                                                                    className="form-control"
                                                                    onChange={this.handleChange}
                                                                    value={this.state.selectedNumber}
                                                                    style={{
                                                                        height: '45px',
                                                                        border: '1px solid #d1d3e2',
                                                                        borderRadius: '6px',
                                                                        fontSize: '14px'
                                                                    }}
                                                                >
                                                                    <option value="">Choose Mobile Number</option>
                                                                    {mobileNumbers.map((item) => (
                                                                        <option key={item.mobile_number} value={item.mobile_number}>
                                                                            {item.mobile_number}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                {this.validator.message('mobile_number', selectedNumber, 'required')}
                                                            </div>
                                                        </div>

                                                        

                                                        {/* Cancellation Reason */}
                                                        <div className="form-group row" style={{ marginBottom: '25px' }}>
                                                            <label className="col-xl-3 col-lg-3 col-form-label" style={{
                                                                fontWeight: '600',
                                                                color: '#5a5c69',
                                                                fontSize: '14px'
                                                            }}>
                                                                Cancellation Reason <span style={{ color: '#e74c3c' }}>*</span>
                                                            </label>
                                                            <div className="col-xl-4 col-lg-4">
                                                                <select
                                                                    className="form-control"
                                                                    value={cancellationReason}
                                                                    onChange={(e) => this.handleInputChange('cancellationReason', e.target.value)}
                                                                    style={{
                                                                        height: '45px',
                                                                        border: '1px solid #d1d3e2',
                                                                        borderRadius: '6px',
                                                                        fontSize: '14px'
                                                                    }}
                                                                >
                                                                    <option value="">Select Reason</option>
                                                                    {cancellationReasons.map((reason, index) => (
                                                                        <option key={index} value={reason.value}>
                                                                            {reason.label}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                {this.validator.message('cancellation_reason', cancellationReason, 'required')}
                                                            </div>
                                                        </div>

                                                       


                                                        {/* Submit Button */}
                                                        <div className="form-group row">
                                                            <div className="col-xl-12 col-lg-12" style={{ textAlign: 'right' }}>
                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-primary"
                                                                    disabled={loading}
                                                                    style={{
                                                                        backgroundColor: '#C11D6C',
                                                                        borderColor: '#C11D6C',
                                                                        padding: '12px 30px',
                                                                        fontSize: '14px',
                                                                        fontWeight: '600',
                                                                        borderRadius: '6px',
                                                                        minWidth: '150px'
                                                                    }}
                                                                >
                                                                    {loading ? 'Processing...' : 'Cancel SIM Only Service'}
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}